import { RefObject, useEffect } from 'react';

function isParentHasClass(el: Element, cssClass: string): boolean {
  const parent = el.parentNode as Element;
  if (parent && parent.nodeName !== 'BODY') {
    if (parent.classList.contains(cssClass)) {
      return true;
    } else {
      return isParentHasClass(parent, cssClass);
    }
  } else {
    return false;
  }
}

export function useClickOutside(ref: RefObject<HTMLElement>, onClickOutside: () => void): void {
  useEffect(() => {
    function handleClickOutside(event: Event) {
      const isNotistack = isParentHasClass(event.target as Element, 'notistack-Snackbar');
      if (ref && ref.current && !ref.current.contains(event.target as Node) && !isNotistack) {
        onClickOutside();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClickOutside]);
}
